module.exports = __webpack_public_path__ + "img/32400.78267bfe.jpg";